import React from 'react';
import { Tabs, TabContent, TabHeader } from '../Tabs';
import styles from './GameDetails.module.scss';
import { GameTileProps, GameClickProps } from '../modular-grid/types';
import GameDetailsFooter from './GameDetailsFooter/GameDetailsFooter';
import GameDetailsTop, {
  GameDetailsTopMessages,
} from './GameDetailsTop/GameDetailsTop';
import GameInfoContent, {
  GameInfoContentMessages,
} from './GameInfoContent/GameInfoContent';
import GameRulesContent from './GameRulesContent/GameRulesContent';
import { UserSessionProvider } from '../UserSessionProvider';
import Category from '../Category';
import { CategoriesWithContentTypes } from '../../types/category/categoryTypes';
import { PortalVerticalGameTilePropTypes } from '../../types/gameTypes';
import config from '../../config';

interface GameDetailsMessages {
  gameInfo: string;
  gameRules: string;
  playButton: string;
  gameDetailsTop: GameDetailsTopMessages;
  gameInfoContent: GameInfoContentMessages;
}
export interface GameDetailsPropTypes {
  game: GameTileProps;
  onGameButtonClick: ({
    game,
    gamePosition,
    sectionTitle,
  }: {
    game: GameClickProps;
    gamePosition: number;
    sectionTitle: string;
  }) => void;
  staticTexts: GameDetailsMessages;
  pageTitle?: string;
  loggedIn: boolean;
  recommendedGames: PortalVerticalGameTilePropTypes[];
}

const GameDetails: React.FC<GameDetailsPropTypes> = ({
  game,
  onGameButtonClick,
  staticTexts,
  pageTitle,
  loggedIn,
  recommendedGames,
}) => {
  if (!game) return null;

  const suggestedGamesCategory: CategoriesWithContentTypes = {
    id: 'Suggested Games',
    view_all_button_visible: false,
    title: 'Suggested Games',
    games: recommendedGames,
    type: 'Game Dual',
    component_type: 'game_grid',
    slides: [
      {
        gameList: recommendedGames,
        type: 'Game Dual',
        gamesLimit: 6,
      },
    ],
  };

  const GameDetailsCmp = (
    <UserSessionProvider loggedIn={loggedIn}>
      <div>
        <GameDetailsTop
          game={game}
          onGameButtonClick={onGameButtonClick}
          staticTexts={staticTexts.gameDetailsTop}
          pageTitle={pageTitle}
        />
        <div className={styles.gameDetailsMain}>
          <Tabs
            initialValue="description"
            tabsTop={
              <>
                <TabHeader name="description">{staticTexts.gameInfo}</TabHeader>
                {game.rules && (
                  <TabHeader name="rules">{staticTexts.gameRules}</TabHeader>
                )}
              </>
            }
            tabsContent={
              <>
                <div className={styles.tabContentWrapper}>
                  <TabContent name="description">
                    <GameInfoContent
                      game={game}
                      staticTexts={staticTexts.gameInfoContent}
                    />
                  </TabContent>
                </div>
                <div className={styles.tabContentWrapper}>
                  <TabContent name="rules">
                    <GameRulesContent game={game} />
                  </TabContent>
                </div>
              </>
            }
          />
          {loggedIn && (
            <Category
              locale={config.locale || config.defaultLocale}
              loggedIn={loggedIn}
              category={suggestedGamesCategory}
              visible={true}
              onGameTileClick={onGameButtonClick as any}
              size={'small'}
            />
          )}
        </div>

        <GameDetailsFooter
          game={game}
          buttonText={staticTexts.playButton}
          pageTitle={pageTitle}
          onGameButtonClick={onGameButtonClick}
        />
      </div>
    </UserSessionProvider>
  );

  return GameDetailsCmp;
};

export default GameDetails;
